import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/ListaEnvio`
const API_ENDPOINT_NODE = `${CONS.API_ENDPOINT_BACK_NODE}/listaEnvios`

export function buscarListaPorVendedor(idVendedor, idPublicacion = null) {
  const params = new URLSearchParams({ idVendedor })
  if (idPublicacion) {
    params.append('idPublicacion', idPublicacion)
  }
  return http.get(`${API_ENDPOINT}?${params.toString()}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las listas de envío.',
      tipoError: 'listaEnvio'
    }
  })
}

export function insertarLista(listaVenta) {
  return http.post(API_ENDPOINT, listaVenta)
}

export function actualizarLista(envios) {
  return http.put(`${API_ENDPOINT}/multiple/`, envios)
}

export function actualizar(envio) {
  return http.post(`${API_ENDPOINT_NODE}/actualizar`, envio)
}

export function eliminarLista(listaEliminar, usuario) {
  return http.delete(`${API_ENDPOINT}/${listaEliminar}/${usuario}`)
}

export function buscarListaPorEmpresa(empid) {
  return http.get(`${API_ENDPOINT}/BuscarPorEmpresa/${empid}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las listas de envío.',
      tipoError: 'listaEnvio'
    }
  })
}
